import { initialDestinationsState, IDestinationsState } from '../state/destinations.state';
import { DestinationsAction } from '../constants';

export const destinationsReducer = (
  state = initialDestinationsState,
  action: any,
): IDestinationsState => {
  switch (action.type) {
    case DestinationsAction.GetDestinationsSuccess: {
      return {
        ...state,
        destinations: action.data.results,
      };
    }

    case DestinationsAction.GetDestinationByIdSuccess: {
      return {
        ...state,
        selectedDestination: action.data,
      };
    }

    case DestinationsAction.PostDestinationSuccess: {
        return {
          ...state,
          destinations: [...state.destinations, action.data],
        };
      }
      
      case DestinationsAction.PutDestinationSuccess: {
        return {
          ...state,
          destinations: state.destinations.map(destination =>
            destination.id === action.data.id ? action.data : destination
          ),
          selectedDestination: action.data
        };
      }
      
      case DestinationsAction.DeleteDestinationSuccess: {
        return {
          ...state,
          destinations: state.destinations.filter(destination => destination.id !== action.id)
        };
      }

    default:
      return state;
  }
};